import script from "./transition-expand-fade.vue?vue&type=script&setup=true&lang=js"
export * from "./transition-expand-fade.vue?vue&type=script&setup=true&lang=js"

import "./transition-expand-fade.vue?vue&type=style&index=0&id=237fd6d0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.16_vue@3.5.16_typescript@5.9.2__webpack@5.99.9_@swc+c_wdn4uuzbn7h75zdmcwelxa3jhq/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-237fd6d0"]])

export default __exports__